function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M16.003 2.67C8.643 2.67 2.67 8.643 2.67 16.003s5.973 13.334 13.333 13.334 13.334-5.974 13.334-13.334c0-7.36-5.974-13.333-13.334-13.333z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0592AF",
  fillRule: "nonzero",
  d: "M20.533 25.793l2.052-1.815-2.6-2.041c.838-.652 1.494-1.517 1.966-2.595.473-1.078.71-2.347.71-3.808v-.698c0-1.533-.278-2.884-.833-4.055-.555-1.171-1.34-2.07-2.353-2.697-1.013-.626-2.171-.94-3.475-.94-1.303 0-2.462.314-3.475.94-1.013.627-1.797 1.526-2.352 2.697-.555 1.17-.833 2.526-.833 4.066v.773c.007 1.504.29 2.834.849 3.99.558 1.157 1.346 2.047 2.363 2.67 1.017.623 2.173.935 3.47.935a6.98 6.98 0 001.181-.097l3.33 2.675zm-4.511-5.22c-1.103 0-1.948-.441-2.536-1.322-.587-.88-.88-2.12-.88-3.717v-.763c.007-1.625.304-2.859.891-3.7.587-.842 1.422-1.262 2.503-1.262 1.089 0 1.927.426 2.514 1.278.587.852.88 2.098.88 3.738v.763c-.006 1.626-.3 2.863-.88 3.711-.58.849-1.411 1.273-2.492 1.273z"
}));

function SvgQuestionPopoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgQuestionPopoutIcon;